import { getHTMLElementFromRoot } from "../utility/helper";
import logger from "./logger";

interface PhnDrawerElement extends HTMLElement {
  openDrawer: (routingKeys?: string | undefined) => Promise<void>;
  closeDrawer: () => Promise<void>
  componentOnReady: () => Promise<void>;
}

async function waitForStencilComponent<T extends HTMLElement>(
  stencilElementName: string
): Promise<T> {
  await customElements.whenDefined(stencilElementName);

  const element = getHTMLElementFromRoot(stencilElementName) as T & {
    componentOnReady?: () => Promise<T>;
  };

  if (typeof element.componentOnReady === "function") {
    await element.componentOnReady();
  }

  return element;
}

export async function openContextualDrawer(): Promise<void> {
  try {
    const contextualDrawer = await waitForStencilComponent<PhnDrawerElement>("phn-nd-contextual-drawer")

    await contextualDrawer.openDrawer();
  } catch (error) {
    logger.error("open-contextual-drawer", error as Error);
  }
}

export async function closeContextualDrawer(): Promise<void> {
  try {
    const contextualDrawer = await waitForStencilComponent<PhnDrawerElement>("phn-nd-contextual-drawer")

    await contextualDrawer.closeDrawer();
  } catch (error) {
    logger.error("close-contextual-drawer", error as Error);
  }
}

export async function openNavigationDrawer(
  initialRoutingKeys?: string,
): Promise<void> {
  try {
    const navigationDrawer = await waitForStencilComponent<PhnDrawerElement>("phn-nd-navigation-drawer-initiater")

    await navigationDrawer.openDrawer(initialRoutingKeys);
  } catch (error) {
    logger.error("open-navigation-drawer", error as Error);
  }
}

export async function closeNavigationDrawer(): Promise<void> {
  try {
    const navigationDrawer = await waitForStencilComponent<PhnDrawerElement>("phn-nd-navigation-drawer-initiater")
    await navigationDrawer.closeDrawer();
  } catch (error) {
    logger.error("close-navigation-drawer", error as Error);
  }
}
